// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"606cb2df","946":"0c84acd1"}[chunkId] + ".chunk.js");